import {useDocumentStore} from '@/components/document/store';
import FileInput from '@/components/form/file-input';
import {DocumentInputField} from '@/engine/types';
import {FieldProps} from '../../meta-field';

export const FileField = ({field, value, handleChange, handleBlur, handleFocus}: FieldProps<DocumentInputField>) => {
  const documentId = useDocumentStore(state => state.meta.id);

  return (
    <FileInput
      documentId={documentId}
      data-testid={`${field.id}-control`}
      required={field.required}
      disabled={field.disabled || field.readonly}
      name={field.id}
      id={field.id}
      value={value}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};
